import script from "./ProductCompare.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCompare.vue?vue&type=script&setup=true&lang=js"

import "./ProductCompare.vue?vue&type=style&index=0&id=bfa41b00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfa41b00"]])

export default __exports__